import { render, staticRenderFns } from "./TplLuaEditor.vue?vue&type=template&id=0242a883&"
import script from "./TplLuaEditor.vue?vue&type=script&lang=js&"
export * from "./TplLuaEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports